@if (workStationType$ | async; as workStationType) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: workStationType }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: workStationType }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <elder-basic-pane-layout class="flex">
      <elder-pane>
        <elder-pane-header>
          <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
          <elder-pane-actions>
            <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
                <mat-icon>delete</mat-icon>
                <span>{{ 'actions.delete' | translate }}</span>
              </button>
            </mat-menu>
          </elder-pane-actions>
        </elder-pane-header>
        <elder-pane-content class="pt-0">
          <form #mainFrm="ngForm" class="flex layout-row gap-xl">
            <elder-pane class="flex layout-col outlined p-pane">
              <div class="layout-row">
                <div class="flex layout-col">
                  <!-- Identifications -->
                  <elder-pane-subtitle>{{
                    'context.identification' | translate
                  }}</elder-pane-subtitle>
                  <div class="layout-col gap-md">
                    <mat-form-field class="flex">
                      <mat-label>{{ 'context.name' | translate }}</mat-label>
                      <input
                        matInput
                        name="name"
                        required
                        placeholder="{{ 'context.name' | translate }}"
                        [(ngModel)]="workStationType.name"
                      />
                    </mat-form-field>
                    <mat-form-field class="flex">
                      <mat-label>{{ 'context.description' | translate }}</mat-label>
                      <input
                        matInput
                        name="description"
                        placeholder="{{ 'context.description' | translate }}"
                        [(ngModel)]="workStationType.description"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </elder-pane>
            <elder-pane class="flex layout-col outlined">
              <div class="flex layout-row gap-xl">
                <!-- properties -->
                <div class="flex layout-col">
                  <elder-pane-subtitle class="p-pane">{{
                    'properties.title' | translate
                  }}</elder-pane-subtitle>
                  <div class="flex layout-row gap-md">
                    <app-property-spec-table
                      class="flex"
                      [propertyKinds]="[PropertyKind.WORK_STATION]"
                      [(specs)]="workStationType.propertySpecs"
                    >
                    </app-property-spec-table>
                  </div>
                </div>
              </div>
            </elder-pane>
          </form>
        </elder-pane-content>
      </elder-pane>
    </elder-basic-pane-layout>
  </div>
}

<ng-template #header let-workStationType>
  @if (creationMode) {
    <span>
      {{ 'shopfloor.workstations.types.new' | translate }}
    </span>
  } @else {
    <elder-header
      [header]="'shopfloor.workstations.types.type' | translate"
      [subheader]="'ID: ' + workStationType.id"
    >
    </elder-header>
  }
</ng-template>
